import {FilterableMultiSelect} from '@carbon/react';
import {Close} from '@carbon/icons-react';

export type Props = {
    specialties: string[];
    selectedSpecialties: string[];
    onChange: (selected: string[]) => void;
    showChips?: boolean;
};

const SpecialtyMultiSelect = ({specialties, selectedSpecialties, onChange, showChips = true}: Props) => {
    const selectedCount = selectedSpecialties.length;
    const selectedText = `${selectedCount} ${selectedCount === 1 ? 'specialty' : 'specialties'} selected`;
    const label = selectedCount === 0 ? 'All specialties' : selectedText;

    return (
        <div data-testid='specialty-multiselect' style={{width: '100%'}}>
            <FilterableMultiSelect
                id='specialty-filter'
                titleText='Specialty'
                hideLabel
                label={label}
                items={specialties}
                itemToString={(item) => item ?? ''}
                selectedItems={selectedSpecialties}
                onChange={({selectedItems}) => onChange(selectedItems ?? [])}
                placeholder={selectedCount === 0 ? 'Search specialties...' : selectedText}
            />
            {showChips && selectedCount > 0 && (
                <div
                    style={{display: 'flex', flexWrap: 'wrap', gap: '0.25rem', marginTop: '0.5rem'}}
                    data-testid='specialty-chips'
                    aria-label='Selected specialties'
                >
                    {selectedSpecialties.map(specialty => (
                        <span
                            key={specialty}
                            data-testid={`specialty-chip-${specialty}`}
                            title={specialty}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.25rem',
                                padding: '0 0.5rem',
                                height: '1.5rem',
                                borderRadius: '0.25rem',
                                background: '#393939',
                                color: '#ffffff',
                                fontSize: '0.75rem',
                                maxWidth: '14rem',
                            }}
                        >
                            <span style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{specialty}</span>
                            <button
                                type='button'
                                title={`Remove ${specialty}`}
                                aria-label={`Remove ${specialty}`}
                                onClick={() => onChange(selectedSpecialties.filter(s => s !== specialty))}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer',
                                    color: 'inherit',
                                    lineHeight: 1,
                                }}
                            >
                                <Close size={12} />
                            </button>
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SpecialtyMultiSelect;
